import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import PartnerSignup from "@/pages/PartnerSignup";
import AcceptInvite from "@/pages/AcceptInvite";
import ResetPassword from "@/pages/ResetPassword";
import MagicLink from "@/pages/MagicLink";
import ChangePassword from "@/pages/ChangePassword";
import BrookeAccess from "@/pages/BrookeAccess";
import Dashboard from "@/pages/Dashboard";
import StartHere from "@/pages/StartHere";
import Modules from "@/pages/Modules";
import ModuleDetail from "@/pages/ModuleDetail";
import Tracks from "@/pages/Tracks";
import TrackDetail from "@/pages/TrackDetail";
import FlashCards from "@/pages/FlashCards";
import Quizzes from "@/pages/Quizzes";
import QuizPlay from "@/pages/QuizPlay";
import Certifications from "@/pages/Certifications";
import Resources from "@/pages/Resources";
import Roleplays from "@/pages/Roleplays";
import Progress from "@/pages/Progress";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminGroups from "@/pages/admin/AdminGroups";
import AdminModulesPage from "@/pages/admin/AdminModulesPage";
import AdminQuizzesPage from "@/pages/admin/AdminQuizzesPage";
import AdminResourcesPage from "@/pages/admin/AdminResourcesPage";
import AdminProgressPage from "@/pages/admin/AdminProgressPage";
import AdminCertificationsPage from "@/pages/admin/AdminCertificationsPage";

import "@/App.css";
import { Toaster } from "sonner";

export default function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/signup" element={<PartnerSignup />} />
                        <Route path="/accept-invite" element={<AcceptInvite />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/auth/magic" element={<MagicLink />} />
                        <Route path="/change-password" element={
                            <ProtectedRoute><ChangePassword /></ProtectedRoute>
                        } />
                        <Route path="/brooke" element={<BrookeAccess />} />

                        <Route element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }>
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/start" element={<StartHere />} />
                            <Route path="/modules" element={<Modules />} />
                            <Route path="/modules/:id" element={<ModuleDetail />} />
                            <Route path="/tracks" element={<Tracks />} />
                            <Route path="/tracks/:slug" element={<TrackDetail />} />
                            <Route path="/flashcards" element={<FlashCards />} />
                            <Route path="/quizzes" element={<Quizzes />} />
                            <Route path="/quizzes/:id" element={<QuizPlay />} />
                            <Route path="/certifications" element={<Certifications />} />
                            <Route path="/resources" element={<Resources />} />
                            <Route path="/roleplays" element={<Roleplays />} />
                            <Route path="/progress" element={<Progress />} />

                            <Route path="/admin" element={
                                <ProtectedRoute roles={["admin", "trainer"]}>
                                    <AdminLayout />
                                </ProtectedRoute>
                            }>
                                <Route path="users" element={
                                    <ProtectedRoute roles={["admin"]}><AdminUsers /></ProtectedRoute>
                                } />
                                <Route path="groups" element={
                                    <ProtectedRoute roles={["admin"]}><AdminGroups /></ProtectedRoute>
                                } />
                                <Route path="modules" element={<AdminModulesPage />} />
                                <Route path="quizzes" element={<AdminQuizzesPage />} />
                                <Route path="resources" element={<AdminResourcesPage />} />
                                <Route path="progress" element={<AdminProgressPage />} />
                                <Route path="certifications" element={<AdminCertificationsPage />} />
                            </Route>
                        </Route>
                    </Routes>
                </BrowserRouter>
                <Toaster position="bottom-right" />
            </AuthProvider>
        </div>
    );
}
